import React from 'react'

const Contact = () => {
    return (
        <>

            <section className='mt-5'>
                <div className="str">
                    <div className="ban-inn ab-ban pg-cont">
                        <div className="container">
                            <div className="row">
                                <div className="hom-ban">
                                    <div className="ban-tit">
                                        <span>We are here to assist you.</span>
                                        <h1>Contact us</h1>
                                        <p>Most Trusted and premium Matrimony Service in the World.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* END */}
            {/* START */}
            <section>
                <div className="ab-sec2 pg-cont">
                    <div className="container">
                        <div className="row">
                            <ul>
                                <li>
                                    <div className="we-here">
                                        <h3>Our office</h3>
                                        <p>Most Trusted and premium Matrimony Service in the World.</p>
                                        <span>
                                            <i className="fa fa-phone" aria-hidden="true" /> +91 044 2432 2858
                                        </span>
                                        <span>
                                            <i className="fa fa-envelope-o" aria-hidden="true" />{" "}
                                            help@cnnmandram.com{" "}
                                        </span>
                                        <span>
                                            <i className="fa fa-map-marker" aria-hidden="true" /> 28800
                                            Orchard Lake Road, Suite 180 Farmington Hills, U.S.A.
                                        </span>
                                    </div>
                                </li>
                                <li>
                                    <div className="we-cont">
                                        <img src="images/icon/trust.png" alt="" />
                                        <h4>Customer Relations</h4>
                                        <p>Most Trusted and premium Matrimony Service in the World.</p>
                                        <a href="#!" className="cta-rou-line">
                                            Get Support
                                        </a>
                                    </div>
                                </li>
                                <li>
                                    <div className="we-cont">
                                        <img src="images/icon/telephone.png" alt="" />
                                        <h4>WhatsApp Support</h4>
                                        <p>Most Trusted and premium Matrimony Service in the World.</p>
                                        <a href="#!" className="cta-rou-line">
                                            Talk to sales
                                        </a>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </section>
        </>

    )
}

export default Contact